<template>
  <div class="student_discuss_wrap">
    <div class="student_discuss_title">
      <div class="student_discuss_tab" v-if="currentRouter=='课堂交流区'">
        <ul>
          <li v-for="(item,key) in tabList" :key="key" @click="toClass(item,key)" :class="{active:listType === key}">
            <span>{{item}}</span>
          </li>
        </ul>
        <div class="switch_wrap">
          <el-switch v-model="teacherPartake" v-if="region=='student'&&(userType==2||userType==3)" @change="changeSwitch" active-text="老师参与" active-color="#5397F7" inactive-color="#E6E6E6"></el-switch>
          <el-switch v-model="ownValue" v-if="!(region=='teacher'&&(userType==0||userType==1))" @change="changeSwitch" active-text="只看我的" active-color="#5397F7" inactive-color="#E6E6E6"></el-switch>
        </div>
      </div>
      <div class="student_discuss_tab" v-if="currentRouter!='课堂交流区'">
        <img src="../../../../../../../static/images/study/icon/luntan_hv.png"/>
        <h2>{{currentRouter}}</h2>
      </div>
      <div class="student_discuss_title_right">
      	<div class="select_wrap" v-if="currentRouter=='课堂交流区'">
        	<el-select class="select_class" v-model="classN" @change="changeClass" placeholder="请选择班级" clearable>
				    <el-option
				      v-for="item in classList"
				      :key="item.id"
				      :label="item.name"
				      :value="item.id">
				    </el-option>
				  </el-select>
        </div>
        <div v-if="currentRouter=='课堂交流区'">
          <div class="discuss_search">
            <el-input v-model="discussSearchValue" @keyup.enter.native="discussSearch" placeholder="请输入讨论主题、回复或评论"></el-input>
            <el-button icon="el-icon-search" @click="discussSearch"></el-button>
          </div>
        </div>
        <div v-if="currentRouter!='课堂交流区'">
          <el-button class="send_discuss" @click="backBiscuss">返 回</el-button>
        </div>
      </div>
    </div>
    <div class="title_msg" v-if="currentRouter=='课堂交流区'">{{introduce}}</div>
    <discussList
     v-if="currentRouter=='课堂交流区'" 
     :discussList="discussList" 
     :region="region" 
     :pageTotal="pageTotal" 
     v-on:changeSwitch="changeSwitch" 
     v-on:jumpDetails="jumpDetails" 
     @currentPageFn="currentPageFn"
     ></discussList>
     <themeDetails
      v-if="currentRouter=='主题详情'&&detailsId!=null" 
      @changeRouter="changeRouter" 
      :region="detailsRegion" :detailsId="detailsId" :classId="classId"></themeDetails>
  </div>
</template>
<script>
import discussList from '../component/discussList'
import themeDetails from '../component/themeDetails'
import * as api from "../../../../../../api/discussApi";
export default {
  inject: ['reload'],
  data() {
    return {
    	tabList: ['最新发表','浏览数','点赞数','回复数'],
      routerList: ['课堂交流区'],
      currentRouter: '课堂交流区',
      introduce: '课堂交流区：发表与课程相关的想法、创意及疑问等',
      discussList:[],
      discussSearchValue: '',
      ownValue: false,
      teacherPartake: false,
      listType: 0,
      isTopNum: 0,
      region: 'student',
      detailsRegion: 'student',
      detailsId: null,
      pageTotal: {
        currentpage: 1,
        pageSize: 10,
        total: 0
      },
      userType: sessionStorage.getItem('userType'),
      classId: '',
      classList: [],
      classN: ''
    }
  },
  components: {
    discussList,
    themeDetails
  },
  mounted() {
    this.getDiscussList(1);
    this.getAllTeachClass();
  },
  watch: {
    detailsId:function(val){
      // console.log(val)
    },
  },
  methods: {
  	// 获取所有的教学班
		getAllTeachClass(){
			let courseId = this.$route.query.courseId;
			api.getAllTeachClass(courseId).then(res=>{
				if(res.code == 0){
					this.classList = res.data;
				}
			})
		},
    getDiscussList(currentpage){
      let obj = {
        courseId: this.$route.query.courseId,
        classId: this.classN,
        type: this.listType,
        name: this.discussSearchValue,
        catalogId: null,
        myContent: this.ownValue, //只看我的
        repliedOrParticipationFlag: this.teacherPartake?1:0, //老师已答复、参与
        discussionAreaId: 3, //1全部、2老师、3课堂
        pageSize: this.pageTotal.pageSize,
        pageNum: currentpage
      }
      api.getCourseAllDiscuss(obj).then(rs=>{
        this.discussList = rs.data.list
        this.pageTotal = {
          currentpage: rs.data.pageNum,
          pageSize: rs.data.pageSize,
          total: rs.data.total
        }
      })
    },
    changeClass(val){
    	this.getDiscussList(1);
    },
    jump(i){
      this.currentRouter = this.routerList[i]
      if(this.routerList.length>1){
        this.routerList = this.routerList.slice(0,i+1)
      }
    },
    discussSearch(){
      this.getDiscussList(1)
    },
    listSwitch(index){
      this.listType = index
      this.getDiscussList(1)
    },
    changeSwitch(val){
      this.ownValue = val;
      this.teacherPartake = val;
      this.getDiscussList(1)
    },
    backBiscuss(){
      if(this.currentRouter=='主题详情'){
        this.currentRouter = '课堂交流区'
      }
    },
    currentPageFn(val){
      this.pageTotal.currentPage = val;
      this.getDiscussList(val)
    },
    jumpDetails(val){
      this.currentRouter = val.router
      this.detailsRegion = val.region
      this.detailsId = val.item.id;
      this.classId = val.item.classId;
      let obj = {
      	learnId: val.item.id,
        type: 0
      }
      api.getDiscussDetail(obj).then(rs=>{
        if(rs.code==0){
          console.log('预览+1')
        }else{
          this.$messageError(rs.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    changeRouter(val){
      this.currentRouter = val.router
      this.region = val.region
    },
    toClass(item,index){
      this.listType = index
      this.getDiscussList(1)
    }
  },
}
</script>
<style lang="scss">
  .student_discuss_wrap{
    height: 100%;
    .title_msg {
    	font-size: 12px;
    	color: #0D141E;
    	padding: 0 23px;
    	margin: 10px 0;
    }
    .student_discuss_title{
      height: 35px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 24px;
      box-sizing: border-box;
      .student_discuss_tab{
        display: flex;
        ul{
          display: flex;
          li{
            position: relative;
            border-right: 1px solid #E6E6E6;
            text-align: center;
            cursor: pointer;
            &:last-child{
              border: none;
            }
            span{
              margin: 0 13px;
              padding: 0 8px;
              color: #5D646E;
              font-size: 12px;
            }
          }
          .active{
            span{
              color: #5397F7;
            }
          }
        }
        img{
          width: 20px;
          height: 20px;
          margin-right: 4px;
        }
        h2{
          font-size:18px;
          font-weight:400;
          color:rgba(51,51,51,1);
          span{
            font-size:14px;
            font-weight:400;
            color:rgba(51,51,51,1);
            cursor: pointer;
            i{
              &:hover{
                color: #5397F7;
              }
            }
          }
        }
      }
      .student_discuss_title_right{
        display: flex;
        div{
          display: flex;
          .discuss_search{
            display: flex;
            .el-input{
              width: inherit;
            }
            input{
              width:200px;
              height:30px;
              border-radius: 4px 0 0 4px;
              font-size: 12px;
            }
            button{
              width:40px;
              height:30px;
              background:rgba(83,151,247,1);
              border-radius:0px 4px 4px 0px;
              padding: 0;
              border: none;
              i{
                color: #fff;
              }
            }
          }
        }
        .send_discuss{
          width:80px;
          height:30px;
          background:#5397F7;
          border:1px solid rgba(83,151,247,1);
          border-radius:4px;
          margin-left: 16px;
          padding: 0;
          color: #fff;
        }
        .select_wrap {
        	.select_class {
						width: 144px;
						margin-right: 14px;
						.el-input__icon {
							line-height: 30px;
						}
						.el-input__inner {
							height: 30px;
							line-height: 30px;
							border-radius: 2px;
						}
					}
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/TeachClass/components/discuss/studentDiscuss/studentDiscuss.vue